package com.wintermar.inspection.feature.presentation.inspection.answer.widget.notes

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalAction
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.cancel
import org.jetbrains.compose.resources.stringResource

@Composable
actual fun NotesModal(
    notes: String,
    title: String,
    labelAction: String,
    show: Boolean,
    onDismiss: () -> Unit,
    onSave: (String) -> Unit
) {
    var countTriggerValidation by remember { mutableStateOf(0) }

    fun handleOnDismiss() {
        countTriggerValidation = 0
        onDismiss()
    }

    ModalDialog(
        show = show,
        title = title,
        onDismiss = { handleOnDismiss() },
        action = ModalAction.default().copy(
            showAction = true,
            widthButtonBasedOnText = true,
            withBackgroundHeader = true,
            label = labelAction,
            secondLabel = stringResource(Res.string.cancel),
            secondOnClick = { handleOnDismiss() },
            onClick = {
                countTriggerValidation++
            }
        )
    ) { verticalPadding ->
        Spacer(modifier = Modifier.height(verticalPadding))
        Notes(
            notes = notes,
            title = title,
            checkValidation = true,
            countTriggerValidation = countTriggerValidation,
            onResult = { value, isError ->
                if (isError) return@Notes

                onSave(value)
                handleOnDismiss()
            }
        )
        Spacer(modifier = Modifier.height(verticalPadding))
    }
}
